<template>
  <div class="app-root">
    <router-view></router-view> <!-- 这里是动态渲染的组件 -->
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted() {
    this.trackTrafficSource();
  },
  methods: {
    trackTrafficSource() {
      const urlParams = new URLSearchParams(window.location.search);
      const source = urlParams.get('from');

      if (source) {
        // 存储来源，用于后续转化归因
        sessionStorage.setItem('traffic_source', source);

        // 等 gtag 加载完毕再发送事件
        const sendEvent = () => {
          if (typeof window.gtag !== 'undefined') {
            window.gtag('event', 'referral_from', {
              'referral_source': source,
              'referral_url': window.location.href
            });
            console.log('Referral source tracked:', source);
          }
        };

        if (typeof window.gtag !== 'undefined') {
          sendEvent();
        } else {
          // gtag 脚本异步加载中，延迟发送
          window.addEventListener('load', () => {
            setTimeout(sendEvent, 500);
          });
        }
      }
    }
  }
}
</script>

<style>
/* Global layout — HomePage overrides background for its route */
#app {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--color-text-900, #1a202c);
  background: var(--color-surface-100, #f3f4f6);
  min-height: 100vh;
}
/* Ensure the app root fills the mount element so child components
   using h-full / height:100% resolve correctly */
.app-root {
  height: 100%;
}
/* Scrollbar styling delegated to glass-theme.css */
</style>
